import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs/internal/Observable";
import { environment } from "../../../environments/environment";
import { ClientAccountNumberResponse } from "../models/client/clientAccountNumberResponse";
import { GenericResponseDto } from "../models/generic-response.dto";
import { CreateProspectDto } from "../models/prospect/addProspect/prospect";
import { VerifyProspectDto } from "../models/prospect/verifyprospect/verifyProspectDto";
import { Contact } from "../models/shared/contact";
import { ClientSearchList } from "../models/shared/clientSearchList";

@Injectable({
  providedIn: "root",
})
export class AddNewProspectService {
  private ProspectManagementBaseURL =
    environment.baseUrl + "/ProspectManagement";
  private clientManagementBaseURL = environment.baseUrl + "/ClientManagement";

  constructor(private _http: HttpClient) {}

  addProspectData(
    payload: CreateProspectDto
  ): Observable<GenericResponseDto<CreateProspectDto>> {
    return this._http.post<GenericResponseDto<CreateProspectDto>>(
      this.ProspectManagementBaseURL + "/AddProspect",
      payload
    );
  }

  getProspectCustomerAccount(): Observable<
    GenericResponseDto<ClientAccountNumberResponse>
  > {
    return this._http.get<GenericResponseDto<ClientAccountNumberResponse>>(
      this.ProspectManagementBaseURL + "/GetProspectAccountNumber"
    );
  }

  verifyProspectData(
    payload: VerifyProspectDto
  ): Observable<GenericResponseDto<VerifyProspectDto>> {
    return this._http.post<GenericResponseDto<VerifyProspectDto>>(
      this.ProspectManagementBaseURL + "/VerifyProspectClients",
      payload
    );
  }

  addClientContactData(
    payload: Contact[]
  ): Observable<GenericResponseDto<Contact[]>> {
    return this._http.put<GenericResponseDto<Contact[]>>(
      this.ProspectManagementBaseURL + "/UpdateProspectContact",
      payload
    );
  }

  getClientByNameAndAccountNumberFilter(
    nameAccountNumber = ""
  ): Observable<GenericResponseDto<ClientSearchList[]>> {
    return this._http.get<GenericResponseDto<ClientSearchList[]>>(
      this.clientManagementBaseURL +
        `/SearchClientByNameOrAccountNumber?nameAccounNumber=${encodeURIComponent(
          nameAccountNumber
        )}`
    );
  }
}
